import { takeLeading, put, call, Effect } from "redux-saga/effects"
import API from "../../../../apis/contextmeeting/api"
import { displayUserMessageAction } from "../../../userMessage/state/userMessageActions"
import { UserMessageTypes } from "../../../userMessage/state/userMessageTypes"
import { clearSession, setSession } from "../../../../app/state/appSessionStorage"
import { AccountActionTypes } from "../accountTypes"
import { userSchema } from "../../../../apis/contextmeeting/schema"
import { normalize } from "normalizr"
import { AxiosError } from "axios"
import { withAuthHeader } from "../../../../apis/contextmeeting/withAuthHeader"

export function* signinWatchers(): Generator {
  yield takeLeading(AccountActionTypes.SIGN_IN_USER_ASYNC_PENDING, signInUserAsync)
  yield takeLeading(AccountActionTypes.SIGN_OUT_USER_ASYNC_PENDING, signOutUserAsync)
  yield takeLeading(AccountActionTypes.USER_SIGN_IN_TYPE_ASYNC_PENDING, userSignInTypeAsync)
  yield takeLeading(AccountActionTypes.SIGN_IN_SWAP_OAUTH_TOKEN, swapOauthToken)
}

export function* signInUserAsync(action): Generator {
  try {
    const body = {
      user: {
        email: action.payload.email,
        password: action.payload.password
      }
    }

    // sending this with auth headers to get the clientId
    const response: any = yield call(API.post, "/signin/", body, withAuthHeader())
    const normalizedResponse = normalize(response.data.user, userSchema)

    const token = response.headers.authorization.split(" ")[1]
    const user = response.data.user
    setSession(token, user.id, user.email)
    yield put({
      type: AccountActionTypes.SIGN_IN_USER_ASYNC_SUCCESS,
      payload: {
        session: {
          id: response.data.id,
          apiToken: token,
        },
        user: normalizedResponse
      }
    })

    // ToDo:
    // If details are missing: send user to "Complete account page",
    // If T&C not agreed: send user to "T&C page"
    // Else: send user to "MEETINGS page" (Dashboard)
  } catch (error) {
    console.error(error)
    yield put({
      type: AccountActionTypes.SIGN_IN_USER_ASYNC_ERROR,
      payload: error
    })
    const errorInstance = error as AxiosError
    if (errorInstance.response.status === 401) {
      yield put(displayUserMessageAction({
        messageKey: "unauthorizedSignInAttempt",
        type: UserMessageTypes.ERROR
      }))
    }
  }
}

export function* swapOauthToken(): Generator {
  try {
    const response: any = yield call(API.post, "/session/swap_token", null, withAuthHeader())
    const normalizedResponse = normalize(response.data.user, userSchema)

    const token = response.headers.authorization.split(" ")[1]
    const user = response.data.user
    setSession(token, user.id, user.email)
    yield put({
      type: AccountActionTypes.SIGN_IN_USER_ASYNC_SUCCESS,
      payload: {
        session: {
          id: response.data.id,
          apiToken: token,
        },
        user: normalizedResponse
      }
    })

    // ToDo:
    // If details are missing: send user to "Complete account page",
    // If T&C not agreed: send user to "T&C page"
    // Else: send user to "MEETINGS page" (Dashboard)
  } catch (error) {
    console.error(error)
    yield put({
      type: AccountActionTypes.SIGN_IN_USER_ASYNC_ERROR,
      payload: error
    })
    const errorInstance = error as AxiosError
    if (errorInstance.response.status === 401) {
      yield put(displayUserMessageAction({
        messageKey: "unauthorizedSignInAttempt",
        type: UserMessageTypes.ERROR
      }))
    }
  }
}

export function* signOutUserAsync(_action: Effect): Generator {
  console.log("signing user out")
  try {
    clearSession()

    yield put({
      type: AccountActionTypes.SIGN_OUT_USER_ASYNC_SUCCESS,
    })
  } catch (_error) {
    yield put({
      type: AccountActionTypes.SIGN_OUT_USER_ASYNC_ERROR,
    })
  }
}

export function* userSignInTypeAsync(action: Effect): Generator {
  try {
    const response: any = yield API.post("/user/type", { email: action.payload })

    yield put({
      type: AccountActionTypes.USER_SIGN_IN_TYPE_ASYNC_SUCCESS,
      payload: { ...response.data }
    })
  } catch (error) {

    yield put({
      type: AccountActionTypes.USER_SIGN_IN_TYPE_ASYNC_ERROR,
      payload: error
    })
  }
}

